import module from '../module';
import Constants from '../../../utils/CommonConstants';

function WidthChangedHandlerLink($rootScope, $timeout, $window, $document, element) {

    let promise = null;

    function applySizes() {
        const width = element[0].offsetWidth;
        $rootScope.sizeXs = width < 600;
        $rootScope.sizeSm = !$rootScope.sizeXs && width < 960;
        $rootScope.sizeMd = !$rootScope.sizeSm && width < 1280;
        $rootScope.sizeLg = !$rootScope.sizeMd && width < 1920;
        $rootScope.sizeXsSm = $rootScope.sizeXs || $rootScope.sizeSm;
    }

    function invokeEvent() {
        promise = null;
        applySizes();
        $rootScope.$emit(Constants.Events.WINDOW_WIDTH_CHANGED, element[0].offsetWidth);
    }

    function handleWindowResize() {

        if (promise) {
            $timeout.cancel(promise);
        }

        promise = $timeout(function () {
            $rootScope.$apply(invokeEvent);
        }, 100);
    }

    element[0].contentWindow.addEventListener('resize', handleWindowResize);

    handleWindowResize();
    applySizes();

    $window.addEventListener('scroll', function () {
        const scrollTop = ($window.pageYOffset || $document[0].documentElement.scrollTop) - ($document[0].documentElement.clientTop || 0);
        $rootScope.$apply(function () {
            $rootScope.$emit(Constants.Events.WINDOW_SCROLL, scrollTop);
        });
    });
}

module.directive('widthChangedHandler', ['$rootScope', '$timeout', '$window', '$document', function ($rootScope, $timeout, $window, $document) {

    return {
        link: function ($scope, element) {
            WidthChangedHandlerLink($rootScope, $timeout, $window, $document, element);
        },
        template: "<iframe style='width:100%;height:0;border:0;padding:0;margin:0;background-color:transparent;position:absolute'></iframe>",
        replace: true
    };
}]);



// WEBPACK FOOTER //
// ./src/modules/shared/directives/WidthChangedHandlerDirective.js